export default "__VITE_ASSET__BTdJyRvq__"